<template>

    <div class="tab-pane fade active show" id="project" role="tabpanel">
        <h6 class="label-bar mb-2">
            <i class="fad fa-bullhorn fa-fw me-1"></i> Dati Progetto
        </h6>
        <div class="cc">

            <div class="row mb-2">
                <div class="col-md-6">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem; width: 100%;">
                        Tipologia Evento:
                        <span class="badge bg-success badge-xs cursor-pointer float-end" @click="apriNuovaTipologia" title="Crea nuova tipologia">nuova</span>
                    </label>
                    <Multiple v-bind:options="filters.toSelect2(arrayTipologie,'ID_OPZIONE_TIPOLOGICA','DESCRIZIONE')" v-model="localProgetto.tipologie"></Multiple>
                </div>
                <div class="col-md-3">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem;">Data Evento:</label>
                    <Datepicker v-model="localProgetto.DATA_EVENTO" model-type="dd/MM/yyyy" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']" :tabindex="3"></Datepicker>
                </div>
                <div class="col-md-3">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem;">Stato:</label>
                    <select class="form-select form-select-sm" v-model="localProgetto.FK_ID_STATO" :tabindex="5">
                        <option value="">Seleziona</option>
                        <option v-for="stato in arrayStatiProgetto" :key="stato.CUSTOM_1" :value="stato.CUSTOM_1">{{ stato.DESCRIZIONE }}</option>
                    </select>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-3">
                    <label class="form-label mb-0" style="font-size: 0.875rem;">Codice Progetto:</label>
                    <input class="form-control form-control-sm bg-light" type="text" :value="localProgetto.CODICE_PROGETTO" readonly placeholder="Generato automaticamente" />
                </div>
                <div class="col-md-9">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem;">Titolo:</label>
                    <input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Titolo Progetto" v-model="localProgetto.TITOLO" :tabindex="6" />
                </div>
            </div>
            
            <div class="row mb-2">
                <div class="col-md-2">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem;">Tipo Cliente:</label>
                    <select class="form-select form-select-sm" v-model="tipoCliente" :tabindex="7">
                        <option value="">Seleziona</option>
                        <option value="persona_giuridica">Azienda</option>
                        <option value="persona_fisica">Persona Fisica</option>
                    </select>
                </div>
                <div class="col-md-6" v-show="tipoCliente == 'persona_giuridica'">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem; width: 100%;">
                        Azienda:
                        <span class="badge bg-success badge-xs cursor-pointer float-end" @click="apriNuovaAzienda" title="Crea nuova azienda">nuova</span>
                    </label>
                    <div class="input-group input-group-sm">
                        <Select2 v-model="localProgetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA" :api="'theb/s2/agenzie'" :apiselected="'theb/s2/agenzie/selected?a=1'" style="width: 100%;" :tabindex="8"></Select2>
                    </div>
                </div>
                <div class="col-md-6" v-show="tipoCliente == 'persona_fisica'">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem; width: 100%;">
                        Persona Fisica:
                        <span class="badge bg-success badge-xs cursor-pointer float-end" @click="apriNuovaPersonaFisica" title="Crea nuova persona fisica">nuova</span>
                    </label>
                    <div class="input-group input-group-sm">
                        <Select2 v-model="localProgetto.INTESTATARIO_FK_ID_PERSONA_FISICA" :api="'theb/s2/persone-fisiche'" :apiselected="'theb/s2/persone-fisiche/selected?a=1'" style="width: 100%;" :tabindex="8"></Select2>
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem;">Budget previsto:</label>
                    <div class="input-group input-group-sm">
                        <span class="input-group-text"><i class="far fa-euro-sign fa-fw"></i></span>
                        <input autocomplete="off" class="form-control" type="text" placeholder="Budget" v-model="localProgetto.BUDGET_PREVISTO" :tabindex="9" />
                    </div>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-12">
                    <label class="form-label mb-0" style="font-size: 0.875rem;">Note:</label>
                    <textarea class="form-control form-control-sm" rows="2" placeholder="Inserisci note aggiuntive..." v-model="localProgetto.NOTE" :tabindex="10"></textarea>
                </div>
            </div>

            <hr class="mt-3 mb-2">

            <div class="row mb-3">
                <div class="col-md-3">
                    <label class="form-label text-danger mb-0" style="font-size: 0.875rem;">Account Evento:</label>
                    <select class="form-select form-select-sm" v-model="localProgetto.FK_ID_UTENTE" :tabindex="10" :disabled="!$root.isGod">
                        <option value="">Seleziona</option>
                        <option v-for="admin in $root.arrayUtentiAdmin" :value="admin.ID_UTENTE" :key="admin.ID_UTENTE">{{ admin.USERNAME }}</option>
                    </select>
                </div>
                <div class="col-md-7">
                    <label class="form-label text-dark mb-0" style="font-size: 0.875rem;">Assegna a utenti</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Cerca utente..." v-model="filtroUtente" :tabindex="11">
                </div>
                <div class="col-md-2">
                    <label class="form-label text-dark mb-0" style="font-size: 0.875rem;">&nbsp;</label>
                    <button type="button" :class="['btn btn-sm w-100', tuttiSelezionati ? 'btn-secondary' : 'btn-primary']"
                        @click="toggleTuttiUtenti" :title="tuttiSelezionati ? 'Deseleziona tutti' : 'Seleziona tutti'">
                        <i class="me-1" :class="tuttiSelezionati ? 'fa fa-times' : 'fa fa-check-double'"></i>
                        {{ tuttiSelezionati ? 'Deselezione' : 'Seleziona' }}
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div ref="utentiScrollContainer" style="overflow-x: auto; max-width: 100%; white-space: nowrap;">
                        <div class="d-flex flex-nowrap" style="gap: 8px;">
                            <div v-for="utente in utentiDisponibili" :key="utente.ID_UTENTE" @click="toggleUtente(utente.ID_UTENTE)" 
                                :class="[ 'd-flex align-items-center rounded-pill px-2 py-1', 
                                utentiSelezionati.includes(utente.ID_UTENTE) ? 'bg-primary text-white' : 'bg-light text-dark' ]"
                                style="min-width: max-content; cursor: pointer; user-select: none;">
                                <div class="me-2">
                                    <img v-if="utente.ID_UTENTE > 0 && utente.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS',utente.URL_AVATAR)" alt="" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover;" />
                                    <i v-else class="fa fa-user" :class="utentiSelezionati.includes(utente.ID_UTENTE) ? 'text-white' : 'text-secondary'" style="font-size: 20px;"></i>
                                </div>
                                <small>{{ utente.USERNAME }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <SchedaAzienda ref="schedaAzienda" :tipo="1" @aziendaSalvata="onAziendaSalvata"></SchedaAzienda>
    <SchedaUtente ref="schedaUtente" @updateGriglia="onPersonaFisicaSalvata"></SchedaUtente>

    <!-- Modal nuova tipologia -->
    <div class="modal fade" id="popUpNuovaTipologia" role="dialog" tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white border-0">
                    <h6 class="modal-title">Nuova Tipologia Evento</h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Descrizione</label>
                        <input type="text" class="form-control form-control-sm" placeholder="Es. Conference, Wedding..." v-model="nuovaTipologiaDescrizione" @keyup.enter="salvaNuovaTipologia" />
                    </div>
                </div>
                <div class="modal-footer bg-light p-2">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
                        <i class="ph-x me-1"></i>Annulla
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary"
                        @click="salvaNuovaTipologia(false)"
                        :disabled="!nuovaTipologiaDescrizione.trim()">
                        <i class="ph-check me-1"></i>Salva e chiudi
                    </button>
                    <button v-if="tipologiaSelezionata.ID_OPZIONE_TIPOLOGICA == 0"
                        type="button" class="btn btn-sm btn-primary"
                        @click="salvaNuovaTipologia(true)"
                        :disabled="!nuovaTipologiaDescrizione.trim()">
                        <i class="ph-check me-1"></i>Salva e continua
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Select2 from '@/components/utils/Select2.vue'
import SchedaAzienda from '@/components/SchedaAzienda.vue'
import SchedaUtente from '@/components/SchedaUtente.vue'
import { VueDatePicker } from '@vuepic/vue-datepicker'
import Multiple from '@/components/utils/Multiple.vue'

export default {
    name: 'TabDatiProgetto',

    components: { Select2, SchedaAzienda, SchedaUtente, Datepicker: VueDatePicker, Multiple },

    props: {
        progetto: { type: Object, required: true },
        utentiSelezionati: { type: Array, required: true },
        arrayStatiProgetto: { type: Array, default: () => [] }
    },

    emits: ['update:utentiSelezionati', 'update:progetto'],

    data() {
        return {
            filters:global.filters,
            filtroUtente: '',
            localProgetto: {
                FK_ID_TIPO: '',
                FK_ID_CATEGORIA: '',
                FLG_VISIBILE: '',
                FK_ID_STATO: '',
                FK_ID_UTENTE: '',
                tipologie:[],
            },
            tipoCliente: '',
            arrayTipologie: filters.getOpzioniTipologiche(61),
            nuovaTipologiaDescrizione: '',
            tipologiaSelezionata: { ID_OPZIONE_TIPOLOGICA: 0 }
        }
    },

    watch: {
        progetto: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val && (!this.localProgetto || JSON.stringify(val) !== JSON.stringify(this.localProgetto))) {
                    this.localProgetto = { ...val };
                    if (this.localProgetto.DATA_EVENTO && /^\d{4}-\d{2}-\d{2}/.test(String(this.localProgetto.DATA_EVENTO))) {
                        this.localProgetto.DATA_EVENTO = this.filters.formatDate(this.localProgetto.DATA_EVENTO);
                    }
                    if (Array.isArray(this.localProgetto.tipologie) && this.arrayTipologie.length > 0) {
                        const validIds = new Set(this.arrayTipologie.map(o => o.ID_OPZIONE_TIPOLOGICA));
                        this.localProgetto.tipologie = this.localProgetto.tipologie.filter(id => validIds.has(id));
                    }
                    if (!this.localProgetto.MODALITA_ESPORTAZIONE_BUDGET) {
                        this.localProgetto.MODALITA_ESPORTAZIONE_BUDGET = '1005';
                    }
                    // Normalizza i valori delle select a stringa vuota se null, undefined o 0
                    if (this.localProgetto.FK_ID_TIPO == null || this.localProgetto.FK_ID_TIPO == 0) {
                        this.localProgetto.FK_ID_TIPO = '';
                    }
                    if (this.localProgetto.FK_ID_CATEGORIA == null || this.localProgetto.FK_ID_CATEGORIA == 0) {
                        this.localProgetto.FK_ID_CATEGORIA = '';
                    }
                    if (this.localProgetto.FLG_VISIBILE == null || this.localProgetto.FLG_VISIBILE == 0) {
                        this.localProgetto.FLG_VISIBILE = '';
                    }
                    if (this.localProgetto.FK_ID_STATO == null || this.localProgetto.FK_ID_STATO == 0) {
                        this.localProgetto.FK_ID_STATO = '';
                    }
                    if (this.localProgetto.FK_ID_UTENTE == null || this.localProgetto.FK_ID_UTENTE == 0) {
                        this.localProgetto.FK_ID_UTENTE = '';
                    }
                    // Per i nuovi progetti, se l'utente è God, forza Account Evento a vuoto
                    if (!this.localProgetto.ID_PROGETTO && this.$root.isGod) {
                        this.localProgetto.FK_ID_UTENTE = '';
                    }
                    // Determina il tipo di cliente in base ai campi popolati
                    if (this.localProgetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA && this.localProgetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA > 0) {
                        this.tipoCliente = 'persona_giuridica';
                    } else if (this.localProgetto.INTESTATARIO_FK_ID_PERSONA_FISICA && this.localProgetto.INTESTATARIO_FK_ID_PERSONA_FISICA > 0) {
                        this.tipoCliente = 'persona_fisica';
                    } else {
                        this.tipoCliente = '';
                    }
                }
            }
        },
        tipoCliente(newVal) {
            // Quando cambia il tipo, resetta l'altro campo a 0
            if (newVal == 'persona_fisica') {
                this.localProgetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA = 0;
            } else if (newVal == 'persona_giuridica') {
                this.localProgetto.INTESTATARIO_FK_ID_PERSONA_FISICA = 0;
            } else if (newVal == '') {
                // Se deseleziona, mette entrambi a 0
                this.localProgetto.INTESTATARIO_FK_ID_PERSONA_FISICA = 0;
                this.localProgetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA = 0;
            }
        },
        // Watch sui campi per mantenere la coerenza
        'localProgetto.INTESTATARIO_FK_ID_PERSONA_FISICA'(newVal) {
            if (newVal && newVal > 0) {
                this.localProgetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA = 0;
            }
        },
        'localProgetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA'(newVal) {
            if (newVal && newVal > 0) {
                this.localProgetto.INTESTATARIO_FK_ID_PERSONA_FISICA = 0;
            }
        },
        localProgetto: {
            deep: true,
            handler(val) {
                if (val) {
                    this.$emit('update:progetto', val);
                }
            }
        }
    },

    computed: {
        utentiDisponibili() {
            if (!this.$root.arrayUtentiAdmin || !Array.isArray(this.$root.arrayUtentiAdmin)) {
                return []
            }
            const testoFiltro = this.filtroUtente.toLowerCase().trim()
            return this.$root.arrayUtentiAdmin.filter(u => {
                if (this.localProgetto?.FK_ID_UTENTE && u.ID_UTENTE == this.localProgetto.FK_ID_UTENTE) return false
                return !testoFiltro || u.USERNAME.toLowerCase().includes(testoFiltro)
            })
        },
        tuttiSelezionati() {
            if (!this.$root.arrayUtentiAdmin || !Array.isArray(this.$root.arrayUtentiAdmin)) {
                return false
            }
            return this.utentiSelezionati.length == this.$root.arrayUtentiAdmin.length
                && this.$root.arrayUtentiAdmin.length > 0
        },
    },

    methods: {
        toggleUtente(idUtente) {
            const updated = [...this.utentiSelezionati]
            const index = updated.indexOf(idUtente)
            if (index == -1) {
                updated.push(idUtente)
            } else {
                updated.splice(index, 1)
            }
            this.$emit('update:utentiSelezionati', updated)
        },
        toggleTuttiUtenti() {
            if (this.tuttiSelezionati) {
                this.$emit('update:utentiSelezionati', [])
            } else {
                this.$emit('update:utentiSelezionati', this.$root.arrayUtentiAdmin.map(u => u.ID_UTENTE))
            }
        },
        apriNuovaAzienda() {
            this.$refs.schedaAzienda.openSchedaAzienda({ ID_AZIENDA: 0, personaGiuridica: {} })
        },
        onAziendaSalvata(azienda) {
            this.$refs.schedaAzienda.chiudi();
            if (azienda?.ID_AZIENDA > 0) {
                this.tipoCliente = 'persona_giuridica';
                this.localProgetto.INTESTATARIO_FK_ID_PERSONA_GIURIDICA = azienda.ID_AZIENDA;
            }
        },
        apriNuovaPersonaFisica() {
            this.$refs.schedaUtente.openSchedaUtente({ ID_UTENTE: 0, persona: {} })
        },
        onPersonaFisicaSalvata() {
            const newId = this.$refs.schedaUtente?.utente?.ID_UTENTE;
            this.$refs.schedaUtente?.chiudi();
            if (newId > 0) {
                this.tipoCliente = 'persona_fisica';
                this.localProgetto.INTESTATARIO_FK_ID_PERSONA_FISICA = newId;
            }
        },
        apriNuovaTipologia() {
            this.tipologiaSelezionata = { ID_OPZIONE_TIPOLOGICA: 0 };
            this.nuovaTipologiaDescrizione = '';
            this.filters.openPopUp("popUpNuovaTipologia");
        },
        salvaNuovaTipologia(continua = false) {
            if (!this.nuovaTipologiaDescrizione.trim()) return;
            const descrizione = this.nuovaTipologiaDescrizione.trim();
            utils.salvaElemento(
                "shared/tipologiche/opzioni/",
                { ...this.tipologiaSelezionata, DESCRIZIONE: descrizione, FK_ID_TIPOLOGICA: 61, FLG_ATTIVO: 1, ICONA: '', CUSTOM_1: '', CUSTOM_2: '' },
                "ID_OPZIONE_TIPOLOGICA",
                "popUpNuovaTipologia",
                (response) => {
                    if (response.esito == 0) {
                        const nuovoId = parseInt(response.id_inserito, 10);
                        this.arrayTipologie = [...this.arrayTipologie, { ID_OPZIONE_TIPOLOGICA: nuovoId, DESCRIZIONE: descrizione }];
                        if (nuovoId && !this.localProgetto.tipologie.includes(nuovoId)) {
                            this.localProgetto.tipologie = [...this.localProgetto.tipologie, nuovoId];
                        }
                        this.$root.startUp();
                        if (continua) {
                            this.tipologiaSelezionata = { ID_OPZIONE_TIPOLOGICA: 0 };
                            this.nuovaTipologiaDescrizione = '';
                        } else {
                            this.filters.closePopUp("popUpNuovaTipologia");
                        }
                    }
                }
            );
        },
    },

    mounted() {
        this.$nextTick(() => {
            const container = this.$refs.utentiScrollContainer
            if (container) {
                container.addEventListener('wheel', (e) => {
                    if (e.deltaY !== 0) {
                        e.preventDefault()
                        container.scrollLeft += e.deltaY
                    }
                })
            }
        })
    }
}
</script>

